<template>
  <div class="search-lib-result-block" v-if="query.length">
    <div class="section" v-if="empty">
      <div class="title empty">{{ $t('libs.search-result.not-found') }}</div>
    </div>
    <div class="section" v-if="results.materials.length">
      <div class="title">{{ $t('libs.search-result.materials-title') }}</div>
      <div class="list">
        <a :href="item.file" target="_blank" class="item" v-for="item in results.materials" :key="item.id">
          {{ item.name }}
          <div class="badge bg" :class="item.additional ? 'primary' : 'dark'">
            {{ getExpansionFile(item.file) }}
          </div>
        </a>
      </div>
    </div>
    <div class="section" v-if="results.videos.length">
      <div class="title">{{ $t('libs.search-result.videos-title') }}</div>
      <div class="list">
        <a :href="item.file" target="_blank" class="item" v-for="item in results.videos" :key="item.id">
          {{ item.name }}
          <div class="badge bg" :class="item.additional ? 'primary' : 'dark'">{{ expansion }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getExpansionFile } from '@/utils/data'

export default {
  name: 'SearchLibResult',
  props: {
    query: String,
  },
  computed: {
    results() {
      const q = this.query.trim().toLowerCase()
      return Object.keys(this.library).reduce((results, key) => {
        results[key] = this.library[key].filter((item) => {
          return this.getSearchString(item).includes(q)
        })
        return results
      }, {})
    },
    empty() {
      return !Object.values(this.results).some((list) => list.length)
    },
    ...mapState('library', ['library']),
  },
  methods: {
    getExpansionFile(file) {
      return getExpansionFile(file)
    },
    getSearchString(item) {
      return (item.name + item.file).toLowerCase()
    },
  },
}
</script>

<style lang="scss">
.search-lib-result-block {
  position: absolute;
  z-index: 10;
  top: 10px;
  left: 0;
  right: 0;
  background: $white;
  box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  padding: 76px 32px 20px;
  max-height: 80vh;
  overflow: auto;

  @include mobile {
    padding-top: 24px;
  }

  .section {
    > .title {
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
      color: $dark;
      margin-top: 30px;
      margin-bottom: 13px;
      padding-left: 10px;

      &.empty {
        font-size: 14px;
        margin: 10px 0;
      }
    }

    .item {
      display: block;
      padding: 10px 30px 10px 13px;
      margin: 5px 0;
      border-radius: 5px;
      color: $text;
      text-decoration: none;
      transition: all 0.25s;
      background: $white no-repeat calc(100% - 20px) center;
      word-break: break-word;

      &:hover {
        background-color: #f7f7f7;
        background-image: url('~@/assets/icons/arrow-r-dark.svg');
      }
    }
  }
}
</style>
